import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PlanDto } from 'app/models/dto';
import { PlanService } from 'app/services/plan.service';
import { UtilserviceService } from 'app/services/utilservice.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {

  plans: Array<PlanDto>=[]
  name= '';
  email='';
  phoneNumber='';
  message='';
  loading = false;
  constructor(private util: UtilserviceService,private planServices:PlanService,private route: Router, private toastr: ToastrService) { }

  public style: any;
  data: any;
  logo: string;
  appName: string;
  hamburger: string;
  displayHamburger = true;
  courses: any;
 async ngOnInit() {
    this.style = this.util.getDomainEnviroment().style;
     this.data = this.util.getDomainEnviroment().data;
     this.logo = this.util.getDomainEnviroment().landingPageLogo;
     this.appName = this.util.getDomainEnviroment().appName;
     this.hamburger = this.util.getDomainEnviroment().hamburger;
     this.util.getsubjects().then(
      (data) =>{
        this.courses = data;     
        console.log('corses', this.courses);
                
      }
    ).catch(e => console.log('error getting plans', e));
  }
  navigateToUpgrade(plan: any) {
    this.route.navigateByUrl("/register");
    this.util.setSelectedPlan(plan);
  }
async  SendMail(){
    if (this.email == null || this.email == undefined || this.email == '') {
      this.toastr.error("Please enter an email address");
      return false;
    }
    if (this.message == null || this.message == undefined || this.message == '') {
      this.toastr.error("Please enter a message");
      return false;
    }
    this.loading = true;
    let data = {
      Name:this.name,
      Email: this.email,
      Message:this.message,
      PhoneNumber: this.phoneNumber
    }
   await this.util.sendContactUs(data).then(() => {
    this.toastr.success("Response sent");
    this.loading = false;
   }).catch((e) => {
    console.log(e);
    this.loading = false;
    this.toastr.error("An error occured");
   });
  }
  toggleHamburger(){
    this.displayHamburger = !this.displayHamburger;
  }  
}
